import { createSceneReducer } from '../../reducers-util';
import contractorsDataReducer from './contractors.data';
import contractorsUiReducer from './contractors.ui';

export default createSceneReducer(contractorsDataReducer, contractorsUiReducer);
